/**
 * Tabs — 수평 탭 네비게이션
 *
 * 탭 목록을 가로로 나열하고 활성 탭에 하단 인디케이터 바를 표시한다.
 * variant로 다양한 시각 스타일 제공
 */

import { ReactNode } from 'react'
import { cn } from '../../lib/cn.js'
import styles from './Tabs.module.css'

export interface TabItem {
  key: string
  label: string
  icon?: ReactNode
}

interface TabsProps {
  items: TabItem[]
  value: string
  onChange: (key: string) => void
  size?: 'sm' | 'md'
  /** 시각 스타일 변형 */
  variant?: 'card' | 'minimal' | 'elegant' | 'flush'
  className?: string
}

export function Tabs({ items, value, onChange, size = 'md', variant = 'card', className }: TabsProps) {
  const activeIndex = items.findIndex((item) => item.key === value)
  const showIndicator = variant !== 'flush' && activeIndex >= 0

  return (
    <div className={cn(styles.root, styles[size], styles[variant], className)} role="tablist">
      {items.map((item) => {
        const isActive = item.key === value
        return (
          <button
            key={item.key}
            role="tab"
            aria-selected={isActive}
            className={cn(styles.tab, isActive && styles.tabActive)}
            onClick={() => onChange(item.key)}
          >
            {item.icon && <span className={styles.icon}>{item.icon}</span>}
            {item.label}
          </button>
        )
      })}
      {showIndicator && (
        <span
          className={styles.indicator}
          style={{
            width: `${100 / items.length}%`,
            transform: `translateX(${activeIndex * 100}%)`,
          }}
        />
      )}
    </div>
  )
}
